import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '@flexisaf/flexibull2/build/theme';

export const ConfigMenuWrapper = styled.div`
  /* display: ${(props) => (props.show ? 'block' : 'none')}; */
  display: block;
  top: 80px;
  right: 0;
  position: fixed;
  width: ${(props) => (props.show ? '250px' : '0')};
  z-index: 987;
  background: ${(props) => props.theme.PrimaryDark};
  color: #fff;
  box-shadow: -5px 0 35px rgba(0, 0, 0, 0.2);
  min-height: calc(100vh - 80px);
  overflow: hidden;
  transition: 0.3s ease-out;
  /* padding: 20px; */
  & .flexi-menu-container {
    width: 250px;
  }
  & ul {
    list-style: none;
    margin: 0;
    padding: 0 15px;
    & li {
      & a,
      .a {
        display: block;
        padding: 10px;
        border-radius: ${(props) => props.theme.PrimaryRadius};
        cursor: pointer;
        transition: 0.2s ease-out;
        color: rgba(255, 255, 255, 0.8);
        & i {
          display: inline-block;
          margin-right: 5px;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
        }
      }
    }
  }
  & .shader {
    position: fixed;
    z-index: -1;
    background: rgba(0, 0, 0, 0.1);
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    display: ${(props) => (props.show ? 'block' : 'none')};
  }
`;

export const ConfigMenu = (props) => (
  <ConfigMenuWrapper show={props.show}>
    <div className="flexi-menu-container">{props.children}</div>
    <div aria-hidden="true" className="shader" onClick={props.clickHide} />
  </ConfigMenuWrapper>
);
ConfigMenu.propTypes = {
  children: PropTypes.node,
  clickHide: PropTypes.func,
  show: PropTypes.bool,
};

export const ResponsiveWrapper = styled.div`
  & .sm-show {
    display: none;
  }
  & .md-show {
    display: none;
  }
  & .payment-section {
    margin-top: 10px;
    padding: 10px;
    border-radius: ${(props) => props.theme.SecondaryBorderRadius};
    margin-bottom: 5px;
    border: 1px dashed ${(props) => props.theme.PrimaryBorderColor};
  }

  ${media.tablet`
      & .md-hide{
          display: none;
      }
      & .sm-hide{
          display: none;
      }
      & .md-show{
          display: block;
      }
      & .sm-show{
          display: block;
      }
    `}
  ${media.phone`
      & .sm-hide{
          display: none;
      }
      & .sm-show{
          display: block;
      }
    `}
    & .top-border {
    border-top: 1px solid ${(props) => props.theme.PrimaryBorderColor};
  }
  & .top-bottom {
    border-bottom: 1px solid ${(props) => props.theme.PrimaryBorderColor};
  }
  & .bordered {
    border: 1px solid ${(props) => props.theme.PrimaryBorderColor};
  }
  & .top-radius {
    border-radius: ${(props) => props.theme.SecondaryRadius}
      ${(props) => props.theme.SecondaryRadius} 0 0;
  }
  & .bottom-radius {
    border-radius: 0 0 ${(props) => props.theme.SecondaryRadius}
      ${(props) => props.theme.SecondaryRadius};
  }
`;

export const UserInfo = styled.div`
  & .flexi-table {
    overflow: unset;
  }
`;
